export enum DestinationType {
  International = 'International',
  Domestic = 'Domestic'
}

export interface FormData {
  title: string;
  well: string;
  destinationType: DestinationType;
  departureDate: string | number | string[] | undefined;
  returnDate: string | number | string[] | undefined;
  expectedEquipmentShipDate: string | number | string[] | undefined;
  leavingFrom: string;
  comment?: string;
  description: string;
  supervisor: IndexKey[];
  rig: IndexKey;
  jobType: IndexKey;
  location: IndexKey;
  jobStage: IndexKey;
  customer: IndexKey;
  customerRepresentative: IndexKey;
  jobNumber: string;
}

export interface IndexKey {
  _id: string;
}

// Type definitions for query responses
export interface QueryResponse<T> {
  data: T[];
}

export const ObjectField = [
  'supervisor',
  'location',
  'customerRepresentative',
  'jobStage',
  'jobType',
  'rig',
  'customer'
];

export const REQUIRED_FIELDS = [
  'well',
  'jobNumber',
  'destinationType',
  'supervisor',
  'expectedEquipmentShipDate',
  'customer',
  'jobType',
  'jobStage',
  'location'
];

export const stageOrder = [
  'New Job',
  'Job Staged',
  'Equipment Shipped',
  'Operator Dispatched',
  'Operator returned',
  'Equipment Returned',
  'Closed',
  'Cancelled'
];
